export default {
  data() {
    return {
      mobile: 660,
      tablet: 768,
      desktop: 1025,
      screenType: '',
    };
  },
  computed: {
    isDesktop() {
      return this.screenType === 'desktop';
    },
    isTablet() {
      return this.screenType === 'tablet';
    },
    isMobile() {
      return this.screenType === 'mobile';
    },
  },
  methods: {
    onScreenResize() {
      const screenWidth = document.documentElement.clientWidth;

      if (!!screenWidth && screenWidth > 0) {
        if (screenWidth <= this.mobile) {
          this.screenType = 'mobile';
        } else if (screenWidth > this.mobile && screenWidth <= this.tablet) {
          this.screenType = 'tablet';
        } else if (screenWidth >= this.desktop) {
          this.screenType = 'desktop';
        }
      }

      this.handleScreenResize(screenWidth);
    },
    // to be over written
    handleScreenResize(screenWidth) {
      // console.log('handleScreenResize in mixin', screenWidth)
    },
  },
  mounted() {
    window.addEventListener('resize', this.onScreenResize);
    this.onScreenResize();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onScreenResize);
  },

};
